/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AggregationMethodEnum } from "./AggregationMethodEnum";
import {
  AggregationMethodEnumFromJSON,
  AggregationMethodEnumFromJSONTyped,
  AggregationMethodEnumToJSON,
  AggregationMethodEnumToJSONTyped,
} from "./AggregationMethodEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PatchedGroundWaterRaster
 */
export interface PatchedGroundWaterRaster {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  aggregationMethod?: AggregationMethodEnum;
  /**
   *
   */
  initialWaterlevel?: string;
  /**
   *
   */
  readonly initialWaterlevelId?: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the PatchedGroundWaterRaster interface.
 */
export function instanceOfPatchedGroundWaterRaster(
  value: object
): value is PatchedGroundWaterRaster {
  return true;
}

export function PatchedGroundWaterRasterFromJSON(json: any): PatchedGroundWaterRaster {
  return PatchedGroundWaterRasterFromJSONTyped(json, false);
}

export function PatchedGroundWaterRasterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedGroundWaterRaster {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    aggregationMethod:
      json["aggregation_method"] == null
        ? undefined
        : AggregationMethodEnumFromJSON(json["aggregation_method"]),
    initialWaterlevel: json["initial_waterlevel"] == null ? undefined : json["initial_waterlevel"],
    initialWaterlevelId:
      json["initial_waterlevel_id"] == null ? undefined : json["initial_waterlevel_id"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function PatchedGroundWaterRasterToJSON(json: any): PatchedGroundWaterRaster {
  return PatchedGroundWaterRasterToJSONTyped(json, false);
}

export function PatchedGroundWaterRasterToJSONTyped(
  value?: Omit<
    PatchedGroundWaterRaster,
    "url" | "simulation" | "initialWaterlevelId" | "uid" | "id"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    aggregation_method: AggregationMethodEnumToJSON(value["aggregationMethod"]),
    initial_waterlevel: value["initialWaterlevel"],
  };
}
